export const siteInfo = {
  name: '缅北黑料',
  slogan: '跨境犯罪打击动态追踪',
  tagline: '持续跟踪缅北相关事件、案件、通报、抓捕与解救进展',
  description:
    '缅北黑料是一个专注于汇总跨境电信诈骗与缅北相关违法犯罪治理动态的资讯站，按时间线整理公开报道、官方通报、抓捕行动与解救进展，帮助读者掌握跨境犯罪打击动态。',
  email: 'tips@mianbei-tracker.example.com',
  since: '2023',
  updatedAt: '2025-09-08',
};

export const categories = [
  {
    key: '事件案件',
    desc: '记录已披露的跨境犯罪案件线索、审理进展与关键事实',
    icon: 'ri-file-list-3-line',
    count: 4,
  },
  {
    key: '抓捕行动',
    desc: '汇总跨境执法协作中的抓捕、押解与移交相关动态',
    icon: 'ri-shield-user-line',
    count: 3,
  },
  {
    key: '解救进展',
    desc: '关注被诱骗、被困人员的解救、遣返与安置信息',
    icon: 'ri-hand-heart-line',
    count: 2,
  },
  {
    key: '官方通报',
    desc: '整理公开渠道发布的通报、提示与专项行动信息',
    icon: 'ri-megaphone-line',
    count: 2,
  },
  {
    key: '警示科普',
    desc: '拆解高发骗局话术与诱骗链路，帮助读者提前识别风险',
    icon: 'ri-lightbulb-flash-line',
    count: 2,
  },
];

export const regions = ['全部地区', '缅甸掸邦北部', '果敢地区', '妙瓦底', '泰缅边境', '缅甸克伦邦'];

export const stats = [
  { label: '站内收录案件条目', value: '1,280', unit: '条', icon: 'ri-folder-shield-2-line' },
  { label: '整理公开通报', value: '436', unit: '份', icon: 'ri-file-paper-2-line' },
  { label: '追踪抓捕动态', value: '212', unit: '起', icon: 'ri-shield-star-line' },
  { label: '记录解救进展', value: '97', unit: '批次', icon: 'ri-hand-heart-line' },
];

export const articles = [
  {
    id: 'guogan-compound-night-operation',
    title: '果敢地区一处电诈园区夜间被查，多批涉案人员被集中移交',
    summary:
      '据多家媒体整理报道，缅甸掸邦北部果敢地区一处被指用于电信诈骗的园区在夜间被集中清查，现场查获电脑、话术脚本等物品，涉案人员随后分批移交处理。',
    category: '抓捕行动',
    region: '果敢地区',
    date: '2025-08-26',
    source: '综合公开报道整理',
    tags: ['电诈园区', '集中清查', '移交'],
    readMinutes: 6,
    featured: true,
    cover:
      'https://readdy.ai/api/search-image?query=misty%20mountain%20border%20region%20at%20night%20with%20distant%20compounds%20and%20faint%20lights%2C%20desaturated%20documentary%20photo%2C%20muted%20warm%20muted%20tones%2C%20serious%20investigative%20editorial%20mood%2C%20no%20people&width=1400&height=900&seq=mianbei-guogan-night-01&orientation=landscape',
    body: [
      {
        type: 'p',
        text: '连日来，围绕缅北电信诈骗园区的清查行动持续受到关注。综合多家媒体整理的信息，位于缅甸掸邦北部果敢地区的一处园区在夜间被集中清查，行动时间选在人员相对集中的时段，以减少涉案人员转移的可能。',
      },
      { type: 'h2', text: '现场情况与查获物品' },
      {
        type: 'p',
        text: '据公开信息描述，清查现场发现大量用于网络诈骗的设备，包括排列密集的电脑终端、多卡手机以及印有多套话术的脚本。部分房间被改造成封闭作业区，门窗加装限位装置，说明该场所在管理上具有较强的控制属性。',
      },
      {
        type: 'list',
        items: [
          '电脑终端与多卡手机，数量以批次登记',
          '成套话术脚本与目标名单模板',
          '用于限制出入的门禁与限位装置',
          '账目登记表与人员名册等书面材料',
        ],
      },
      { type: 'h2', text: '移交与后续处理' },
      {
        type: 'p',
        text: '按照公开报道的表述，现场涉案人员随后分批移交，进入身份核查与分类处理的流程。对于被诱骗、被胁迫参与的人员，通常需要结合其在园区内的具体角色、有无实施诈骗行为以及是否主动求助等因素区分处理。',
      },
      {
        type: 'quote',
        text: '跨境案件的办理难点，往往不在于现场清查本身，而在于后续的身份甄别、证据固定与跨法域协作。',
      },
      {
        type: 'p',
        text: '需要说明的是，园区清查只是治理链条中的一环。要真正压缩犯罪空间，还需要从招募链条、资金通道、通信工具等多个环节同时收紧。',
      },
    ],
  },
  {
    id: 'myawaddy-rescue-batch-return',
    title: '妙瓦底方向被困人员分批返回，家属通过线索渠道持续报备',
    summary:
      '围绕妙瓦底一带被困人员的解救与遣返，近期出现多批次返回的情况。相关渠道同步提示家属尽早报备有效信息，以提高核查与对接效率。',
    category: '解救进展',
    region: '妙瓦底',
    date: '2025-08-19',
    source: '综合公开报道整理',
    tags: ['解救', '遣返', '家属报备'],
    readMinutes: 5,
    featured: true,
    cover:
      'https://readdy.ai/api/search-image?query=dawn%20river%20crossing%20at%20the%20border%20with%20silhouettes%20of%20people%20walking%20in%20the%20distance%2C%20desaturated%20documentary%20photo%2C%20muted%20warm%20tones%2C%20serious%20editorial%20mood%2C%20no%20recognizable%20faces&width=1400&height=900&seq=mianbei-myawaddy-rescue-02&orientation=landscape',
    body: [
      {
        type: 'p',
        text: '妙瓦底位于泰缅边境一带，因多起被困人员求助事件而受到持续关注。近期公开报道显示，被困人员正以分批形式返回，相关核查与对接工作同步推进。',
      },
      { type: 'h2', text: '家属报备需要注意什么' },
      {
        type: 'p',
        text: '从公开指引看，家属在报备时提供的信息越具体，核查效率通常越高。与其反复描述情绪，不如一次性把关键信息整理清楚，减少来回确认的成本。',
      },
      {
        type: 'list',
        items: [
          '失联人员的姓名、年龄与身份证件信息',
          '最后可确认的所在地点与时间节点',
          '与家人联系的记录、通话号码与聊天截图',
          '对方索要款项的账号信息与话术特征',
          '家属可随时接听的固定联系电话',
        ],
      },
      { type: 'h2', text: '关于所谓「赎金」的常见误区' },
      {
        type: 'p',
        text: '公开通报多次提示，因轻信所谓「交钱放人」而导致二次损失的案例并不少见。在未核实对方身份与真实性之前，贸然转账往往会暴露家属的支付能力，反而增加风险。',
      },
      {
        type: 'quote',
        text: '遇到索要款项的情形，先核实、再沟通、留证据，比急着筹钱更重要。',
      },
      {
        type: 'p',
        text: '对被解救人员而言，返回之后的心理支持与就业帮扶同样重要。脱离高控制环境后的适应期，需要家庭与社会支持的共同参与。',
      },
    ],
  },
  {
    id: 'telecom-fraud-case-trial-progress',
    title: '一起跨境电信诈骗案件推进审理，涉案环节从招募延伸到资金结算',
    summary:
      '公开信息显示，一起跨境电信诈骗案件的审理正在推进，案情覆盖人员招募、话术培训、资金结算等多个环节，呈现出链条化、分工化的特征。',
    category: '事件案件',
    region: '缅甸掸邦北部',
    date: '2025-08-12',
    source: '综合公开报道整理',
    tags: ['案件审理', '资金通道', '链条分工'],
    readMinutes: 7,
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20courtroom%20bench%20with%20stacked%20documents%20and%20a%20gavel%2C%20muted%20desaturated%20tones%2C%20serious%20documentary%20editorial%20photography%2C%20no%20people&width=1200&height=800&seq=mianbei-case-trial-03&orientation=landscape',
    body: [
      {
        type: 'p',
        text: '跨境电信诈骗案件往往呈现出明显的链条特征。从公开披露的案情看，一个相对完整的链条通常包含招募、转运、话术培训、实施诈骗、资金结算与洗白等环节，各环节之间以利益分配相互绑定。',
      },
      { type: 'h2', text: '招募环节如何运作' },
      {
        type: 'p',
        text: '招募端常见的话术是把境外工作包装成「高薪、包吃住、报销路费」。一旦当事人抵达，证件与通信工具会被集中管理，活动范围受到限制，此时再想脱身就变得困难。',
      },
      { type: 'h2', text: '资金结算的隐蔽性' },
      {
        type: 'p',
        text: '资金端通常通过多层级账户与第三方支付通道快速分散，单笔金额被刻意拆小，以规避监测。这也解释了为什么治理工作必须同时覆盖通信与金融两端。',
      },
      {
        type: 'list',
        items: [
          '多层账户快速过渡，缩短资金停留时间',
          '分散为小额交易，降低单笔异常度',
          '借助他人身份信息开立账户作为通道',
        ],
      },
      {
        type: 'quote',
        text: '打掉一个园区，不等于打掉一条链条；真正的成效要看招募、资金与通信是否同步收紧。',
      },
    ],
  },
  {
    id: 'kokang-arrest-transfer-cooperation',
    title: '跨境执法协作推进，多批涉案人员完成移交程序',
    summary:
      '围绕缅北相关案件，跨境执法协作持续推进，多批涉案人员在完成身份核查后移交处理，协作重点集中在证据互认与信息互通。',
    category: '抓捕行动',
    region: '果敢地区',
    date: '2025-08-05',
    source: '综合公开报道整理',
    tags: ['执法协作', '移交', '证据'],
    readMinutes: 6,
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=generic%20handcuffs%20on%20a%20plain%20wooden%20desk%20beside%20a%20stack%20of%20files%2C%20muted%20desaturated%20tones%2C%20serious%20documentary%20editorial%20photography%2C%20no%20people&width=1200&height=800&seq=mianbei-transfer-04&orientation=landscape',
    body: [
      {
        type: 'p',
        text: '跨境案件的办理，离不开不同法域之间的协作。近期公开信息显示，多批涉案人员在完成身份核查程序后陆续移交，协作的重点集中在证据标准互认与情报信息互通。',
      },
      { type: 'h2', text: '为什么身份甄别耗时长' },
      {
        type: 'p',
        text: '园区内人员构成复杂，既有主动参与者，也有被诱骗、被胁迫者。甄别过程需要结合住宿记录、通信记录、资金流水与同案人员的陈述相互印证，因此难以在短时间内完成。',
      },
      {
        type: 'quote',
        text: '把「参与」与「被胁迫」区分清楚，既是对当事人的负责，也是案件质量的底线。',
      },
      {
        type: 'p',
        text: '对公众而言，理解这一过程的复杂性，有助于减少对「为何不能一次抓完」的误解。跨境治理更像是长期收紧的绳索，而不是一锤子买卖。',
      },
    ],
  },
  {
    id: 'official-notice-scam-recruitment-alert',
    title: '公开提示汇总：警惕以「高薪务工」为名的境外诱骗招募',
    summary:
      '多份公开提示反复强调同一类风险，即以高薪务工、免费旅游等名义实施的境外诱骗招募，提醒公众尤其是年轻人提高警惕。',
    category: '官方通报',
    region: '泰缅边境',
    date: '2025-07-28',
    source: '综合公开提示整理',
    tags: ['招募诱骗', '风险提示', '高薪务工'],
    readMinutes: 5,
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=old%20newspaper%20archive%20stack%20with%20a%20magnifying%20glass%20resting%20on%20top%2C%20muted%20desaturated%20warm%20tones%2C%20serious%20documentary%20editorial%20photography%2C%20no%20people&width=1200&height=800&seq=mianbei-notice-05&orientation=landscape',
    body: [
      {
        type: 'p',
        text: '从多份公开提示中可以归纳出一条清晰的红线：凡是把境外工作描述得「门槛极低、回报极高」的招募，都值得高度警惕。',
      },
      { type: 'h2', text: '常见诱骗话术拆解' },
      {
        type: 'list',
        items: [
          '承诺月入数万、无需经验、包吃包住',
          '声称先到边境城市「面试」再统一出境',
          '以免费旅游、代购带货为名约见',
          '要求上交身份证件或保管护照',
        ],
      },
      { type: 'h2', text: '出境前的自查清单' },
      {
        type: 'p',
        text: '在决定出境务工前，建议通过正规渠道核实招聘主体资质，与家人保持行程同步，并保留完整沟通记录。若对方拒绝说明具体雇主与工作内容，基本可以判定存在风险。',
      },
      {
        type: 'quote',
        text: '真正正规的境外岗位，不会回避雇主是谁、具体做什么这两件事。',
      },
    ],
  },
  {
    id: 'victim-family-beware-second-loss',
    title: '被困人员家属求助避坑指南：识别二次索财的常见套路',
    summary:
      '在人员被困后，部分家属会收到各类索财信息。整理公开案例可以发现，二次索财套路往往有相似特征，识别这些特征能有效减少损失。',
    category: '警示科普',
    region: '综合',
    date: '2025-07-21',
    source: '综合公开案例整理',
    tags: ['防骗', '家属', '二次损失'],
    readMinutes: 6,
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=close%20up%20of%20an%20unmarked%20envelope%20and%20a%20blank%20notepad%20on%20a%20dark%20desk%2C%20muted%20desaturated%20tones%2C%20serious%20documentary%20editorial%20photography%2C%20no%20people&width=1200&height=800&seq=mianbei-family-warning-06&orientation=landscape',
    body: [
      {
        type: 'p',
        text: '家属在焦急状态下最容易做出非理性决策，而这恰恰是二次索财者利用的空间。把套路拆开来看，很多话术其实经不起推敲。',
      },
      { type: 'h2', text: '三种高频套路' },
      {
        type: 'list',
        items: [
          '声称「认识内部人员」可协调放人，先付定金',
          '伪造定位、照片或视频，制造紧迫感要求尽快转账',
          '反复加价，每次都以「只差最后一步」为由拖延',
        ],
      },
      { type: 'h2', text: '遇事三步走' },
      {
        type: 'p',
        text: '第一步是核实对方身份，要求提供可交叉验证的信息；第二步是保留全部沟通证据，包括账号、聊天与转账记录；第三步是通过正规渠道反映情况，避免私下交易。',
      },
      {
        type: 'quote',
        text: '在紧迫感被刻意制造出来的场合，慢一步往往就是最正确的选择。',
      },
    ],
  },
  {
    id: 'compound-management-records-analysis',
    title: '从园区管理记录看高控制环境：打卡、罚款与「业绩考核」',
    summary:
      '公开披露的园区管理记录显示，高控制环境通常依靠打卡制度、罚款规则与「业绩考核」维持运转，这些材料也成为案件办理中的重要证据。',
    category: '事件案件',
    region: '缅甸克伦邦',
    date: '2025-07-14',
    source: '综合公开报道整理',
    tags: ['园区管理', '证据材料', '控制手段'],
    readMinutes: 6,
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=stacks%20of%20handwritten%20ledger%20pages%20and%20clipboards%20on%20a%20long%20table%2C%20muted%20desaturated%20warm%20tones%2C%20serious%20documentary%20editorial%20photography%2C%20no%20people&width=1200&height=800&seq=mianbei-records-07&orientation=landscape',
    body: [
      {
        type: 'p',
        text: '要理解园区为何能长期运转，管理记录提供了直接的切口。公开材料中反复出现打卡表、罚款单与考核榜这三类文书。',
      },
      { type: 'h2', text: '制度如何形成控制' },
      {
        type: 'p',
        text: '这些文书表面上是「绩效管理」，实质是通过经济处罚与人身限制叠加，压缩个人的选择空间。欠款被不断累积，脱身成本随之抬高。',
      },
      {
        type: 'quote',
        text: '当离开的代价被不断抬高，留下来就不再是「选择」，而是一种被动状态。',
      },
      {
        type: 'p',
        text: '对案件办理而言，这类文书能够反映组织架构与分工，是认定角色与责任的重要参考。',
      },
    ],
  },
  {
    id: 'cross-border-telecom-tools-crackdown',
    title: '通信与支付工具双向收紧，跨境诈骗的技术成本正在上升',
    summary:
      '公开信息显示，围绕通信工具与支付通道的治理正在同步推进，这使跨境诈骗获取作案工具的成本明显上升，但同时也带来手法翻新的新挑战。',
    category: '官方通报',
    region: '综合',
    date: '2025-07-06',
    source: '综合公开报道整理',
    tags: ['通信治理', '资金通道', '技术对抗'],
    readMinutes: 5,
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20tangle%20of%20network%20cables%20and%20a%20discarded%20mobile%20phone%20on%20concrete%2C%20muted%20desaturated%20tones%2C%20serious%20documentary%20editorial%20photography%2C%20no%20people&width=1200&height=800&seq=mianbei-telecom-08&orientation=landscape',
    body: [
      {
        type: 'p',
        text: '诈骗链条对通信与支付工具的依赖度极高。当这两端被同时收紧，链条的运转成本就会上升，这是治理能产生实效的关键原因。',
      },
      { type: 'h2', text: '治理的着力点' },
      {
        type: 'list',
        items: [
          '集中治理批量注册的通信账号',
          '打击「两卡」买卖与出租出借',
          '压缩异常资金通道的生存空间',
        ],
      },
      {
        type: 'p',
        text: '与此同时，手法翻新的速度也不容忽视。部分团伙转向更隐蔽的沟通方式，这对监测能力提出了更高要求。',
      },
      {
        type: 'quote',
        text: '治理不是一次性动作，而是与手法翻新之间的持续拉锯。',
      },
    ],
  },
  {
    id: 'missing-to-located-timeline-method',
    title: '从失联到找到人：一条求助线索是如何被推进的',
    summary:
      '家属在人员失联后往往不知从何入手。梳理公开指引可以发现，一条有效线索的推进通常遵循信息整理、渠道反映、核查对接三个步骤。',
    category: '解救进展',
    region: '妙瓦底',
    date: '2025-06-29',
    source: '综合公开指引整理',
    tags: ['线索梳理', '求助流程', '家属指引'],
    readMinutes: 7,
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=a%20single%20flashlight%20and%20a%20folded%20map%20on%20a%20table%20at%20night%2C%20muted%20desaturated%20tones%2C%20serious%20documentary%20editorial%20photography%2C%20no%20people&width=1200&height=800&seq=mianbei-timeline-09&orientation=landscape',
    body: [
      {
        type: 'p',
        text: '焦急的家属最常见的做法是到处留言求助，但信息分散反而降低了可用性。更有效的方式是先做一次系统整理。',
      },
      { type: 'h2', text: '第一步：把信息整理成一页纸' },
      {
        type: 'p',
        text: '姓名、证件号、最后联系时间、已知位置、聊天记录、对方账号，这些信息按时间顺序排列，能显著减少后续反复确认的环节。',
      },
      { type: 'h2', text: '第二步：通过正规渠道反映' },
      {
        type: 'p',
        text: '把整理好的材料通过官方渠道提交，并保留提交凭证。多渠道同时反映时，注意保持信息一致，避免出现互相矛盾的说法。',
      },
      { type: 'h2', text: '第三步：耐心等待核查对接' },
      {
        type: 'p',
        text: '核查需要时间，期间应保持联系电话畅通。若有人以「能加急」「有内部关系」为由索要费用，应提高警惕。',
      },
      {
        type: 'quote',
        text: '有效的求助不是声音大，而是信息准。',
      },
    ],
  },
  {
    id: 'young-recruits-social-prevention',
    title: '年轻人为何容易落入境外招聘陷阱：三个心理缺口',
    summary:
      '从公开案例看，落入境外招聘陷阱的年轻人往往并非缺乏判断力，而是被求职焦虑、同伴压力与信息差三个缺口同时击中。',
    category: '警示科普',
    region: '综合',
    date: '2025-06-18',
    source: '综合公开案例整理',
    tags: ['青年群体', '招聘陷阱', '心理分析'],
    readMinutes: 6,
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=empty%20job%20interview%20room%20with%20two%20chairs%20and%20a%20desk%20under%20cold%20light%2C%20muted%20desaturated%20tones%2C%20serious%20documentary%20editorial%20photography%2C%20no%20people&width=1200&height=800&seq=mianbei-youth-10&orientation=landscape',
    body: [
      {
        type: 'p',
        text: '把责任简单归结为「贪心」并不准确。公开案例显示，多数当事人是在就业压力与熟人介绍的双重作用下做出决定的。',
      },
      { type: 'h2', text: '三个心理缺口' },
      {
        type: 'list',
        items: [
          '求职焦虑：急于在短时间内解决收入问题',
          '同伴压力：看到熟人「去了并赚钱」而动摇',
          '信息差：对出境务工的合法路径缺乏了解',
        ],
      },
      {
        type: 'p',
        text: '阻断诱骗，除了事后打击，更需要在求职环节提前介入，让年轻人知道合法路径长什么样。',
      },
      {
        type: 'quote',
        text: '骗局最怕的不是警惕，而是「我知道正规的路该怎么走」。',
      },
    ],
  },
  {
    id: 'border-liaison-case-review',
    title: '跨法域案件回顾：证据标准差异如何影响办案节奏',
    summary:
      '跨境案件常常因为不同法域的证据标准差异而放慢节奏。回顾公开案例可以看到，证据转换与互认是影响办案效率的关键变量。',
    category: '事件案件',
    region: '缅甸掸邦北部',
    date: '2025-06-09',
    source: '综合公开报道整理',
    tags: ['证据标准', '跨境办案', '协作'],
    readMinutes: 7,
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=two%20stacks%20of%20documents%20on%20either%20side%20of%20a%20desk%20implying%20comparison%2C%20muted%20desaturated%20tones%2C%20serious%20documentary%20editorial%20photography%2C%20no%20people&width=1200&height=800&seq=mianbei-evidence-11&orientation=landscape',
    body: [
      {
        type: 'p',
        text: '同一份证据，在不同法域下可能具有不同的证明力。跨境案件因此需要在取证阶段就把标准对齐，否则后期容易反复补正。',
      },
      { type: 'h2', text: '常见的三种摩擦' },
      {
        type: 'list',
        items: [
          '电子数据的提取程序要求不一致',
          '证人证言的采信规则存在差异',
          '文书翻译与认证流程耗时较长',
        ],
      },
      {
        type: 'p',
        text: '为减少摩擦，协作双方通常会在案件早期就明确取证清单与转换方式，把问题前移解决。',
      },
      {
        type: 'quote',
        text: '跨境协作的效率，很大程度取决于前期把标准谈清楚的程度。',
      },
    ],
  },
];

export const faqs = [
  {
    q: '本站的内容来源是什么？',
    a: '本站内容以公开报道、公开通报与公开指引为基础进行整理归纳，会在条目中标注整理来源与时间。我们不发布未经核实的个人指控，也不提供任何规避法律的建议。',
  },
  {
    q: '为什么有些条目没有写明具体人名？',
    a: '为保护当事人合法权益、避免影响正在办理的案件，本站对涉案人员信息做淡化处理，只保留与事实判断相关的关键信息，例如时间、地点、环节与行为类型。',
  },
  {
    q: '家人疑似被困在缅北，应该先做什么？',
    a: '建议先系统整理一页纸信息，包括姓名、证件信息、最后联系时间、已知位置、聊天记录与对方账号，然后通过官方渠道反映情况，并保持联系电话畅通。切勿轻信所谓「交钱放人」。',
  },
  {
    q: '收到「高薪境外务工」邀请，怎么判断真伪？',
    a: '重点看两点：对方能否说明具体雇主是谁、具体做什么。凡是回避这两个问题、只强调回报的，风险都很高。出境前务必通过正规渠道核实招聘主体资质。',
  },
  {
    q: '本站会发布读者提供的线索吗？',
    a: '读者可以通过线索提供表单联系我们。所有线索会先经过核实与结构化整理，确认具备公开价值且不涉及个人信息泄露后，才会以整理后的形式呈现。',
  },
  {
    q: '如何订阅本站的内容更新？',
    a: '目前可通过关于我们页面留下联系方式，我们会在有重要通报或进展汇总时发送简报。频率不高，只在确有值得关注的内容时推送。',
  },
];

export const testimonials = [
  {
    name: '林先生',
    role: '被困人员家属',
    text: '最有用的是那篇求助指引。我们把信息整理成一页纸之后再反映，回复效率明显高了很多，少走了不少弯路。',
    avatar:
      'https://readdy.ai/api/search-image?query=neutral%20portrait%20silhouette%20avatar%20illustration%20in%20muted%20warm%20paper%20tones%2C%20minimal%20editorial%20style&width=200&height=200&seq=mianbei-avatar-01&orientation=squarish&nocache=true',
  },
  {
    name: '陈老师',
    role: '中学安全教育教师',
    text: '讲招聘陷阱的那几篇很适合拿来做班会材料，讲的是心理缺口而不是简单说教，学生听得进去。',
    avatar:
      'https://readdy.ai/api/search-image?query=neutral%20portrait%20silhouette%20avatar%20illustration%20in%20muted%20warm%20paper%20tones%2C%20minimal%20editorial%20style&width=200&height=200&seq=mianbei-avatar-02&orientation=squarish&nocache=true',
  },
  {
    name: '周女士',
    role: '反诈志愿者',
    text: '按时间线整理的通报汇总很省事，做宣传材料时可以快速找到对应的背景信息，不用来回翻各个平台。',
    avatar:
      'https://readdy.ai/api/search-image?query=neutral%20portrait%20silhouette%20avatar%20illustration%20in%20muted%20warm%20paper%20tones%2C%20minimal%20editorial%20style&width=200&height=200&seq=mianbei-avatar-03&orientation=squarish&nocache=true',
  },
];

export const principles = [
  {
    icon: 'ri-focus-3-line',
    title: '只做事实整理',
    desc: '以公开信息为基础，标注来源与时间，不做主观定性，不发布未经核实的个人指控。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '保护当事人',
    desc: '对涉案与被困人员信息做淡化处理，避免二次伤害，不披露可能导致身份识别的细节。',
  },
  {
    icon: 'ri-time-line',
    title: '持续更新',
    desc: '按时间线维护条目，重要进展及时补充，让读者能看到事件如何一步步推进。',
  },
  {
    icon: 'ri-book-open-line',
    title: '面向实用',
    desc: '不止于记录，更希望帮助读者识别风险、知道遇事该怎么做，把信息转化为实际的防护能力。',
  },
];